import { BAND, BAND_TEXT } from "../lib/constants";
import { Inbox, Upload, Sparkles, Users, Tag } from "lucide-react";

// Reusable lead-origin marker. Add new origins to SOURCE_META and every card/row
// that renders <LeadSourceBadge source={lead.source} /> picks them up automatically.
const SOURCE_META = {
  "Mailbox Auto-Scan": { label: "Inbox", Icon: Inbox, color: "#3E8F99" },
  "Mailbox Discovery": { label: "Inbox", Icon: Inbox, color: "#3E8F99" },
  "Bulk Import": { label: "Import", Icon: Upload, color: "#7A6BB0" },
  "CSV Import": { label: "Import", Icon: Upload, color: "#7A6BB0" },
  Apollo: { label: "Apollo", Icon: Sparkles, color: "#C26A2E" },
  Kaspr: { label: "Kaspr", Icon: Sparkles, color: "#C26A2E" },
  "Warm Network": { label: "Network", Icon: Users, color: "#2F7A3E" },
};

export function LeadSourceBadge({ source, className = "" }) {
  if (!source) return null;
  const key = Object.keys(SOURCE_META).find((k) => source.startsWith(k));
  const m = key
    ? SOURCE_META[key]
    : { label: source.length > 14 ? source.slice(0, 12) + "…" : source, Icon: Tag, color: "#94A3AD" };
  const { label, Icon, color } = m;
  return (
    <span data-testid="lead-source-badge" title={`Source: ${source}`}
      className={`inline-flex items-center gap-1 font-mono text-[9px] uppercase tracking-wider px-1.5 py-0.5 rounded shrink-0 ${className}`}
      style={{ backgroundColor: `${color}1A`, color }}>
      <Icon className="w-2.5 h-2.5" /> {label}
    </span>
  );
}

export function BandBadge({ band, score }) {
  return (
    <span
      className="inline-flex items-center gap-1.5 px-2 py-0.5 font-mono text-[11px] font-semibold uppercase tracking-wider rounded-none border"
      style={{ background: BAND[band], color: BAND_TEXT[band], borderColor: BAND[band] }}
      data-testid={`band-badge-${band}`}
    >
      {band} {score != null && <span className="tabular-nums">· {score}</span>}
    </span>
  );
}

export function StatusChip({ status }) {
  const map = {
    open: ["OPEN", "#3E8F99"], won: ["WON", "#2F7A3E"], lost: ["LOST", "#B23A2E"],
    disqualified: ["DISQUALIFIED", "#94A3AD"], dnc: ["DNC", "#1C2530"], nurture: ["NURTURE", "#E2711D"],
  };
  const [label, color] = map[status] || [status?.toUpperCase(), "#94A3AD"];
  return (
    <span className="font-mono text-[10px] font-semibold uppercase tracking-wider px-1.5 py-0.5 border"
      style={{ color, borderColor: color }}>
      {label}
    </span>
  );
}
